/**
 * Window events the editor uses to ask its HOST for something. The editor
 * knows nothing about the Vault (StudioTopBarActions owns TheGoldsmith dialog),
 * so it asks by name instead of importing host code.
 */
export const OPEN_GOLDSMITH_EVENT = "studio:open-goldsmith";
